<mat-dialog-content>{{message}}</mat-dialog-content>
<mat-dialog-actions class="dual">
    <button mat-button [color]="okColor" (click)="close(true)">{{okTitle}}</button>
    <button mat-button [color]="cancelColor" (click)="close(false)" i18n>{{cancelTitle}}</button>
</mat-dialog-actions>